import {addBookAction , editBookAction} from "./actions";

export default (state={} , action) => {
    switch (action.type) {
        case addBookAction.resultAction :
        case editBookAction.resultAction :
            return action.payload.data ;
        default :
            return state ;
    }
}